module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-10@2x-b0bc16b21288494c3803099f6d0c6ff9.png";